import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  margin: 60px auto 0;
  width: 100%;
  padding: 0 30px;
  max-width: 1260px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  @media (${mobileXXLargeMax}) {
    display: none;
  }

  thead th {
    background-color: ${(props) => props.theme.textDark};
    color: ${(props) => props.theme.white};
    text-align: left;
    padding: 10px;
    border-right: 1px solid ${(props) => props.theme.keyline};
  }

  tbody td {
    padding: 10px;
    color: ${(props) => props.theme.textDark};
    border: 1px solid ${(props) => props.theme.keyline};
  }

  tbody tr:nth-child(2n + 2) td {
    background-color: ${(props) => props.theme.backgroundLightest};
  }
`;

export const SmallText = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.textLight};
`;

export const MobileTable = styled.div`
  display: none;

  @media (${mobileXXLargeMax}) {
    display: block;
  }
`;

export const MobileTableBox = styled.div`
  border: 1px solid ${(props) => props.theme.keyline};
  border-bottom: none;
  padding: 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  h3,
  h5 {
    color: ${(props) => props.theme.textDark};
    margin-bottom: 15px;
  }

  h6 {
    color: ${(props) => props.theme.textLight};
    font-size: 14px;
    margin-top: -15px;
    margin-bottom: 15px;
  }

  h5,
  h6 {
    font-weight: normal;
  }

  &:last-child {
    border-bottom: 1px solid ${(props) => props.theme.keyline};
  }

  &:nth-child(2n + 2) {
    background-color: ${(props) => props.theme.backgroundLightest};
  }
`;

export const MoreDevelopmentsGroup = styled.div`
  background-color: ${(props) => props.theme.backgroundLightest};
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 60px 0;

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const MoreDevelopmentsText = styled.div`
  display: flex;
  flex-direction: row;

  svg {
    margin-right: 15px;
  }

  h4 {
    color: ${(props) => props.theme.textDark};
    font-size: 20px;
  }

  p {
    color: ${(props) => props.theme.textLight};
    font-size: 16px;
  }

  b {
    color: ${(props) => props.theme.primary};
  }

  @media (${laptopMediumMax}) {
    margin-bottom: 30px;
    flex-direction: column;
    align-items: center;

    svg {
      margin: 0 0 15px 0;
    }

    h4,
    p {
      text-align: center;
    }
  }
`;
